import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { GerenciarPermissoesService } from '@services/gerenciar-permissoes.service';
import { Wso2CoreService } from '@services/wso2-core.service';
import _get from 'lodash/get';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { GerenciarPermissoesEnderecosComponent } from './gerenciar-permissoes-enderecos/gerenciar-permissoes-enderecos.component';
import { GerenciarPermissoesPermissoesComponent } from './gerenciar-permissoes-permissoes/gerenciar-permissoes-permissoes.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-gerenciar-permissoes',
    templateUrl: './gerenciar-permissoes.component.html',
    styleUrls: ['./gerenciar-permissoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, RouterLink, PopoverDirective, MatSlideToggle, FormsModule, NgClass, GerenciarPermissoesEnderecosComponent, GerenciarPermissoesPermissoesComponent, FooterComponent]
})
export class GerenciarPermissoesComponent implements OnInit {

  public idContato: any;
  public resource: any;
  public loadingGenerico: boolean = false;
  public senha: any;
  public erro: boolean = false;
  public erroSenha: boolean = false;

  public alertSucessoSubtitulo: any = 'Sucesso !';
  public alertSucessoMensagem: any = 'Senha adicionada com sucesso.';

  public alertErroSubtitulo: any = 'Erro ao adicionar senha !';
  public alertErroMensagem: string = '';

  public alertSucesso: boolean = false;

  public enabled : boolean;

  obj: any = {
    idContato: 0,
    senhaContato: "string"
  }

  @ViewChild('permissoesTab') permissoesTab: ElementRef;
  public selectedAddressParent: number[] = [];

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly gerenciarPermissoesService: GerenciarPermissoesService, private readonly Toastr: ToastrService,
    private readonly wso2CoreService: Wso2CoreService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.idContato = params;
      }
    );
    this.getContato();
    this.getEnderecosPermissoes();
  }

  public getContato() {

    this.loadingGenerico = true;
    this.gerenciarPermissoesService.getContato(this.idContato.id)
    .pipe(take(1)).subscribe({
        next: (success: any) => {
            this.loadingGenerico = false;
            this.resource = success.response;
            this.enabled = success.response?.temAcesso === 'S';
            this.erro = false;
        },
        error: () => {
            this.erro = true;
            this.loadingGenerico = false;
        }
    });
  }

  public getEnderecosPermissoes() {

    this.loadingGenerico = true;
    this.gerenciarPermissoesService.getPermissoes(this.idContato.id)
    .subscribe({
        next: (success: any) => {
            this.selectedAddressParent = _get(success, 'response.0.idEndereco');
        },
        error: () => {}
    });
  }

  public permissoesFoward(event : any) {

    if (event.length > 0) {
      this.selectedAddressParent = event;
      setTimeout(() => {
        this.permissoesTab.nativeElement.click();
      }, 0);
    }
    else {
      this.Toastr.error('Selecione um endereço!', '', {
        timeOut: 3000,
      });
    }
  }

  public fecharAlertSucesso() {
    this.alertSucesso = false;
  }

  public fecharAlertErro() {
    this.erroSenha = false;
  }

  public toggleUser(event: MatSlideToggleChange) {
      const checked = event.checked;
      const checkedPhrase = checked ? 'Ativado' : 'Desativado';
      this.wso2CoreService.toggleUser(this.idContato.id, checked)
      .subscribe({
          next: (response: any) => {
              this.Toastr.success(`Contato ${checkedPhrase} com sucesso`, '', {
                  timeOut: 2000,
              });
          },
          error: (err: any) => {
              this.Toastr.error(`Erro ao ${checkedPhrase} o contato`);
          }
      });
  }
}
